import { Component, OnInit } from '@angular/core';

@Component({
    selector: 'app-pricettool-index',
    templateUrl: './pricet-tool-index.component.html',
    standalone: false
})
export class PricetToolIndexComponent implements OnInit {
  constructor() {}

  ngOnInit() {}
}
